const API_URL = "https://manatorsk-wizard-express-production.up.railway.app/api/returns/create-return-ticket";

let returnPayload = null;

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#return-request-form");
  const confirm = document.querySelector("#return-request-confirm");
  const success = document.querySelector("#return-request-success");
  const summary = document.querySelector("#return-request-summary");
  const backBtn = document.querySelector("#return-request-back");
  const sendBtn = document.querySelector("#return-request-send");
  const steps = document.querySelectorAll(".return-request__step");
  const stepsContainer = document.querySelector(".return-request__steps");

  if (!form || !confirm || !success || !summary || !backBtn || !sendBtn) return;

  function setStep(step) {
    steps.forEach((el) => {
      const stepNum = Number(el.dataset.step);
      el.classList.toggle("return-request__step--active", stepNum === step);
      el.classList.toggle("return-request__step--done", stepNum < step);
    });
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const formData = new FormData(form);

    returnPayload = {
      name: formData.get("name"),
      email: formData.get("email"),
      orderNumber: formData.get("orderNumber"),
      message: formData.get("message")
    };

    summary.textContent = `Du är på väg att utöva din ångerrätt för order ${returnPayload.orderNumber}.`;

    form.hidden = true;
    confirm.hidden = false;
    setStep(2);
  });

  backBtn.addEventListener("click", () => {
    confirm.hidden = true;
    form.hidden = false;
    setStep(1);
  });

  sendBtn.addEventListener("click", async () => {
    sendBtn.disabled = true;
    sendBtn.textContent = "Skickar...";

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(returnPayload)
      });

      const data = await res.json();

      if (!res.ok || data.status !== "ok") {
        throw new Error(data.message || "Kunde inte skicka begäran");
      }

      confirm.hidden = true;
      success.hidden = false;
      if (stepsContainer) stepsContainer.hidden = true;
    } catch (error) {
      sendBtn.disabled = false;
      sendBtn.textContent = "Bekräfta ångerrätt";
      alert(
        error instanceof Error
          ? error.message
          : "Något gick fel. Kontakta oss på contact@manatorsk.com."
      );
    }
  });
});
